import { toast } from 'react-toastify'
import { getAllGroups, getCompleteGroups } from '../../api/super/groups'
import {
  getAllSchools,
  getAllSchoolsForGroups,
  getAllSchoolsForUsers,
  getSchoolFeaturesById,
  getSuperAllRoles,
} from '../../api/super/schools'
import { getAllGroupUsers, getAllUsers } from '../../api/super/Users'
import {
  GroupResponse,
  Role,
  RolesDataResponse,
  UserCountResponse,
  UserResponse,
} from '../../utils/types'

export interface schoolData {
  no: string
  schoolId: string
  role: string
  id: string
  town: string
  verificationStatus: string
  country: string
  postcode: string
  createdBy: string
  userId: string
  groupId: string
  partnerId: string
  status: string
  integrationDate: string
  addressLineOne: string
  addressLineTwo: string
  groupName: string
  brandConfig: {
    fonts: string
    colors: string
  }
  logo: string
  name: string
  isDeleted: string
  updatedAt: string
  createdAt: string
}

export interface schoolApiResponseObj {
  data: schoolData[]
  count: string
}
export interface schoolApiResponse {
  status: string
  data: schoolApiResponseObj
}

export interface FeaturesObj {
  id: string
  schoolId: string
  permissions: string[]
  createdAt: string
  updatedAt: string
}

export interface schoolFeatures {
  school: schoolData
  features: FeaturesObj
}

export interface schoolFeaturesResponse {
  data: schoolFeatures
  status: string
}

export const getSuperScoolData = async (
  currentPage: number
): Promise<schoolApiResponseObj> => {
  const response = (await getAllSchools(currentPage)) as schoolApiResponse

  if (response?.status != 'successful') {
    console.log('error')
  }
  return response?.data
}

export const getSuperScoolDataUser =
  async (): Promise<schoolApiResponseObj> => {
    const response = (await getAllSchoolsForUsers()) as schoolApiResponse

    if (response?.status != 'successful') {
      console.log('error')
    }
    return response?.data
  }

export const getSuperUserRroles = async (): Promise<Role[]> => {
  const response = (await getSuperAllRoles()) as RolesDataResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getSuperScoolGroupData =
  async (): Promise<schoolApiResponseObj> => {
    const response = (await getAllSchoolsForGroups()) as schoolApiResponse

    if (response?.status != 'successful') {
      console.log('error')
    }
    return response?.data
  }

export const getGroupsData = async (): Promise<GroupResponse> => {
  const response = (await getCompleteGroups()) as GroupResponse

  if (response?.status != 'successful') {
    console.log('error')
  }
  return response
}

export const getSuperUserData = async (
  currentPage: number
): Promise<UserCountResponse> => {
  const response = (await getAllUsers(currentPage)) as UserResponse

  if (response?.status != 'successful') {
    console.log('error')
  }
  return response?.data
}

export const getSuperGroupData = async (
  currentPage: number
): Promise<GroupResponse> => {
  const response = (await getAllGroups(currentPage)) as GroupResponse

  if (response?.status != 'successful') {
    console.log('error')
  }
  return response
}

export const getSuperGroupUserData = async (
  currentPage: number
): Promise<UserCountResponse> => {
  const response = (await getAllGroupUsers(currentPage)) as UserResponse

  if (response?.status != 'successful') {
    console.log('error')
  }
  return response?.data
}

export const getSuperSchoolFeatures = async (
  id: string
): Promise<schoolFeaturesResponse> => {
  const response = (await getSchoolFeaturesById(id)) as schoolFeaturesResponse

  if (response?.status != 'successful') {
    console.log('error')
  }
  return response
}
